import React from 'react';
import { Lock, FileCheck, ShieldAlert, Activity, ScrollText, Power } from 'lucide-react';

const ITEMS = [
  { Icon: Lock, label: 'ENCRYPTED BROKER TOKEN HANDLING' },
  { Icon: FileCheck, label: 'PAPER MODE TESTING' },
  { Icon: ShieldAlert, label: 'RISK LOCKOUT RULES' },
  { Icon: Activity, label: 'ADMIN MONITORING' },
  { Icon: ScrollText, label: 'AUDIT LOGS' },
  { Icon: Power, label: 'EMERGENCY KILL SWITCH' },
];

export default function TrustStrip() {
  return (
    <div
      data-testid="trust-strip"
      className="border-t border-[rgba(201,162,75,0.16)] bg-[#0A0A0B]"
    >
      <div className="max-w-[1440px] mx-auto px-5 sm:px-6 lg:px-12 py-3">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-x-4 gap-y-2">
          {ITEMS.map(({ Icon, label }) => (
            <div
              key={label}
              className="flex items-center gap-2 text-[9px] sm:text-[10px] tracking-[0.18em] font-mono text-[#A99563]"
            >
              <Icon size={12} className="gold-text shrink-0" strokeWidth={1.8} />
              <span className="leading-snug truncate">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
